import { useFormik } from "formik"
import React, { useEffect } from "react"
import * as Yup from "yup"
import DatePicker from "react-datepicker"
import Select from "react-select"
import { Col, Input, Label, Row, Form, FormFeedback } from "reactstrap"
import TableContainer from "components/Common/TableContainer"
import moment from "moment"
import { onUpdateTeams } from "store/createTeam/action"
import { useDispatch } from "react-redux"
import { customStylesSelect } from "common/data/settings"
const ManageTeamForm = ({
  teamList,
  filtersubCategory,
  setfiltersubCategory,
  selectedData,
  handleCancel,
  setselectedData,
  companySetting,
  disable,
  toggle,
}) => {
  const dispatch = useDispatch()
  // Handle End Date
  const endDateChange = (date, selectedvalue) => {
    // const obj = selectedData?.teamMembers.findIndex(el => {
    //   return el.userid === selectedvalue.userid
    // })
    // var tempData = selectedData?.teamMembers.map((item, index) => {
    //   if (index === obj) {
    //     return { ...item, endDate: moment(new Date(date)).format("YYYY-MM-DD") }
    //   }
    //   return item
    // })
    // setselectedData({ ...selectedData, teamMembers: tempData })
    var tempData = selectedData?.teamMembers.map(item => {
      if (item?.userId === selectedvalue.userId) {
        return { ...item, endDate: moment(new Date(date)).format("YYYY-MM-DD") }
      }
      return item
    })
    setselectedData({ ...selectedData, teamMembers: tempData })
  }
  // Handle Start Date
  const ModalstartDate = (date, selectedvalue) => {

    var tempData = selectedData?.teamMembers.map(item => {
      if (item?.userId === selectedvalue.userId) {
        return {
          ...item,
          startDate: moment(new Date(date)).format("YYYY-MM-DD"),
        }
      }
      return item
    })
    setselectedData({ ...selectedData, teamMembers: tempData })
  }
  // Handle Active Checkbox
  const activechange = (value, selectedvalue) => {
    const obj = selectedData?.teamMembers.findIndex(
      el => el.userid === selectedvalue.userid
    )
    var tempData = selectedData.teamMembers.map((item, index) => {
      if (index === obj) {
        return { ...item, active: value?.target?.checked }
      }
      return item
    })
    setselectedData({ ...selectedData, teamMembers: tempData })
  }
  const columns = React.useMemo(() => {
    const result = [
      {
        Header: "UserName",
        accessor: "username",
        disableFilters: true,
        filterable: true,
      },

      {
        Header: "Start Date",
        accessor: "startDate",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => (
          <div>
            <DatePicker
              wrapperClassName="datePicker"
              dateFormat="yyyy-MM-dd"
              selected={new Date(cellProps?.row?.original?.startDate)}
              onChange={value =>
                ModalstartDate(value, cellProps?.row?.original)
              }
              className="form-control mb-0 date-icon-back"
              placeholderText="Select date"
              // minDate={new Date(cellProps?.row?.original?.startDate)}
            />
          </div>
        ),
      },
      {
        Header: "End Date",
        accessor: "endDate",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => (
          <div>
            <DatePicker
              wrapperClassName="datePicker"
              dateFormat="yyyy-MM-dd"
              selected={
                cellProps?.row?.original?.endDate &&
                new Date(cellProps?.row?.original?.endDate)
              }
              onChange={value => endDateChange(value, cellProps?.row?.original)}
              className="form-control mb-0 date-icon-back"
              placeholderText="Select date"
              minDate={new Date(cellProps?.row?.original?.startDate)}
              // maxDate={new Date()}
            />
          </div>
        ),
      },

      {
        Header: "Active",
        accessor: "active",
        disableFilters: true,
        minWidth: 50,
        width: 50,
        Cell: cellProps => (
          <div style={{ padding: 10 }}>
            {" "}
            <Input
              className="form-check-input"
              type="checkbox"
              id="active"
              defaultChecked={
                cellProps.row.original.active == true ? true : false
              }
              onChange={value => activechange(value, cellProps?.row?.original)}
            />
          </div>
        ),
      },
    ]
    return result
  }, [selectedData])

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      id: selectedData.id,
      //   active: el.active,
      maincategory:
        { label: selectedData.categoryname, value: selectedData.categoryid } ||
        "",
      subcategory:
        {
          label: selectedData.subcategoryname,
          value: selectedData.subcategoryid,
        } || "",
      reportTo:
        { label: selectedData.reporttoname, value: selectedData.reporttoid } ||
        "",
      user:
        selectedData?.teamMembers?.map(item => {
          return {
            ...item,
            label: item.username,
            value: item.userid,
          }
        }) || "",
      supervisorname:
        {
          label: selectedData.supervisorname,
          value: selectedData.supervisorid,
        } || "",
      startDate: moment(new Date()).format("YYYY-MM-DD") || new Date(),
    },
    validationSchema: Yup.object().shape({}),
    onSubmit: values => {
      const mergeUserDatas = selectedData?.teamMembers?.map(el => ({
        userId: el.userId,
        startDate: el?.startDate,
        endDate: el?.endDate,
        // status: el.durationList?.[0]?.approved,
      }))
      const mergeUserDatasID = values.user?.map(el => ({
        userId: el.userId,
      }))
      const userid = JSON.parse(localStorage.getItem("authUser") || "{}")?.data
        ?.id
      const updateTeam = {
        categoryId: values?.maincategory?.value,
        subCategoryId: values.subcategory?.value,
        reportTo: values?.reportTo?.value,
        supervisorId: values?.supervisorname?.value,
        teammembers: mergeUserDatasID,
        id: 0,
        updatedBy: userid,
        startDate: values?.startDate,
        previousSupervisorId: 0,
        previousReportingTo: 0,
        teamupdatemembers: mergeUserDatas,
        teamuserId: 0,
        teamsupervisorId: 0,
        teamdurationId: 0,
      }
      dispatch(onUpdateTeams(updateTeam, handleResponse))
    },
  })
  const handleResponse = status => {
    if (status === "SUCCESS") {
      toggle()
    }
  }
  //handle sub-category
  useEffect(() => {
    const filteredData = teamList?.subCategoryLookup?.filter(
      el => el?.categoryId == validation.values.maincategory
    )
    setfiltersubCategory(filteredData)
  }, [validation.values.maincategory])
  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        validation.handleSubmit()
        return false
      }}
    >
      <Col md="12" className="mt-2 mb-2">
        <Row form>
          <Col md="4">
            <div>
              <Label htmlFor="formrow-state-Input">
                {companySetting.MainCategory}
              </Label>
              <Select
                id="user"
                name="maincategory"
                defaultValue={validation.values.maincategory}
                onBlur={validation.handleBlur}
                onChange={value => {
                  validation.setFieldValue("maincategory", value)
                }}
                options={teamList?.categoryLookup?.map(el => ({
                  ...el,
                  label: el.name,
                  value: el.id,
                }))}
                classNamePrefix="select2-selection"
                styles={customStylesSelect}
              />
              {validation.touched.maincategory &&
              validation.errors.maincategory ? (
                <FormFeedback type="invalid">
                  {validation.errors.maincategory}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col md="4">
            <div>
              <Label htmlFor="formrow-state-Input">
                {companySetting.SubCategory}
              </Label>
              <Select
                id="user"
                name="subcategory"
                defaultValue={validation.values.subcategory}
                onBlur={validation.handleBlur}
                onChange={value => {
                  validation.setFieldValue("subcategory", value)
                }}
                options={filtersubCategory?.map(el => ({
                  ...el,
                  label: el.name,
                  value: el.id,
                }))}
                styles={customStylesSelect}
                classNamePrefix="select2-selection"
              />
              {validation.touched.subcategory &&
              validation.errors.subcategory ? (
                <FormFeedback type="invalid">
                  {validation.errors.subcategory}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col md="4">
            <div>
              <Label htmlFor="formrow-state-Input">Report To</Label>
              <Select
                id="reportTo"
                name="reportTo"
                value={validation.values.reportTo}
                onBlur={validation.handleBlur}
                onChange={value => {
                  validation.setFieldValue("reportTo", value)
                }}
                options={teamList?.reportToLookup?.map(el => ({
                  ...el,
                  label: el.userName,
                  value: el.userId,
                }))}
                styles={customStylesSelect}
                classNamePrefix="select2-selection"
              />
              {validation.touched.reportTo && validation.errors.reportTo ? (
                <FormFeedback type="invalid">
                  {validation.errors.reportTo}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <div className="mt-2">
              <Label htmlFor="formrow-state-Input">Supervisor</Label>

              <Select
                id="supervisorname"
                name="supervisorname"
                isDisabled={disable}
                value={validation.values.supervisorname}
                placeholder={
                  validation.values
                    ? validation.values.supervisorname
                    : "Select..."
                }
                onBlur={validation.handleBlur}
                onChange={validation.handleChange}
                options={teamList?.teamSupervisorLookup?.map(el => ({
                  ...el,
                  label: el.userName,
                  value: el.userId,
                }))}
                styles={customStylesSelect}
                classNamePrefix="select2-selection"
              />

              {validation.touched.supervisorname &&
              validation.errors.supervisorname ? (
                <FormFeedback type="invalid">
                  {validation.errors.supervisorname}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col md="4">
            <div className="mt-2">
              <Label htmlFor="formrow-state-Input">User</Label>
              <Select
                isMulti
                id="user"
                name="user"
                defaultValue={validation.values.user}
                onBlur={validation.handleBlur}
                onChange={value => {
                  validation.setFieldValue("user", value)
                }}
                options={teamList?.teamMemberLookup?.map(el => ({
                  ...el,
                  label: el.userName,
                  value: el.userId,
                }))}
                styles={customStylesSelect}
                classNamePrefix="select2-selection"
              />
            </div>
          </Col>
          <Col md="4">
            <div className="mt-2">
              <Label htmlFor="formrow-state-Input">Start Date</Label>
              <DatePicker
                wrapperClassName="datePicker"
                dateFormat="yyyy-MM-dd"
                selected={new Date(validation.values.startDate)}
                onChange={value => validation.setFieldValue("startDate", value)}
                className="form-control mb-0 date-icon-back"
                placeholderText="Select date"
              />
            </div>
          </Col>
        </Row>
        <TableContainer
          data={selectedData?.teamMembers || []}
          columns={columns}
          customPageSize={40}
          hidepagination={true}
        />
      </Col>

      <div className="text-end">
        <button
          type="submit"
          className="btn btn-primary save-customer me-2"
        >
          Save
        </button>
        <button
          type="button"
          color="primary"
          className="btn btn-secondary"
          onClick={handleCancel}
        >
          Cancel
        </button>
      </div>
    </Form>
  )
}

export default ManageTeamForm
